import { IContentCreate, IContentListSearch, IEditContentPayload } from "../../../../types/master/contentInterface";
import api from "../../../../lib/api";

export const createContentApi = async (data: IContentCreate) => {
  return await api.post(`/content`, data);
};

export const getContentListApi = async (data: IContentListSearch) => {
  return await api.get(`content/${data.page}/${data.pageLimit}?search=${data?.search ?? ""}`);
};

export const getContentDataByIdApi = async (id: number) => {
  return await api.get(`/content/${id}`);
};

export const editContentDataByIdApi = async (payload: IEditContentPayload) => {
  return await api.put(`/content/${payload.id}`, payload.data);
};
